// extracted by mini-css-extract-plugin
module.exports = {"component":"LinkButton_component__4VbEq","rivals":"LinkButton_rivals__xPlmP"};